import { useContext } from "react";
import AuthContext from "./connections/auth/AuthProvider";

export default function LogOut() {
  const { logoutUser } = useContext(AuthContext);
  logoutUser();
}
